import React, { Component } from "react";
import { Tag } from "primereact/tag";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Panel } from "primereact/panel";
import "primeicons/primeicons.css";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { ToggleButton } from "primereact/togglebutton";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { Toast } from "primereact/toast";
import { Multiselect } from "multiselect-react-dropdown";
import { Button } from "primereact/button";

class Travel_Group extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetGroups = this.SetGroups.bind(this);
    this.toast = React.createRef();
    let Mounth = {
      one: [],
      two: [],
      three: [],
      four: [],
      five: [],
      six: [],
      seven: [],
      eight: [],
      nine: [],
      ten: [],
      eleven: [],
      toelve: [],
    };
    let week = [
      "یکشنبه",
      "دوشنبه",
      "سه شنبه",
      "چهارشنبه",
      "پنج شنبه",
      "جمعه",
      "شنبه",
    ];
    let showDiv = 0;

    for (let i = 0; i < 12; i++) {
      for (let j = 1; j <= 31; j++) {
        let item = {
          label: j + "",
        };
        if (i == 0) {
          Mounth.one.push(item);
        }
        if (i == 1) {
          Mounth.two.push(item);
        }
        if (i == 2) {
          Mounth.three.push(item);
        }
        if (i == 3) {
          Mounth.four.push(item);
        }
        if (i == 4) {
          Mounth.five.push(item);
        }
        if (i == 5) {
          Mounth.six.push(item);
        }
        if (i == 6) {
          Mounth.seven.push(item);
        }
        if (i == 7 && j != 31) {
          Mounth.eight.push(item);
        }
        if (i == 8 && j != 31) {
          Mounth.nine.push(item);
        }
        if (i == 9 && j != 31) {
          Mounth.ten.push(item);
        }
        if (i == 10 && j != 31) {
          Mounth.eleven.push(item);
        }
        if (i == 11 && j != 31) {
          Mounth.toelve.push(item);
        }
      }
    }
    if (Mounth.toelve.length > 0) showDiv = 11;
    if (Mounth.eleven.length > 0) showDiv = 10;
    if (Mounth.ten.length > 0) showDiv = 9;
    if (Mounth.nine.length > 0) showDiv = 8;
    if (Mounth.eight.length > 0) showDiv = 7;
    if (Mounth.seven.length > 0) showDiv = 6;
    if (Mounth.six.length > 0) showDiv = 5;
    if (Mounth.five.length > 0) showDiv = 4;
    if (Mounth.four.length > 0) showDiv = 3;
    if (Mounth.three.length > 0) showDiv = 2;
    if (Mounth.two.length > 0) showDiv = 1;
    if (Mounth.one.length > 0) showDiv = 0;
    this.state = {
      layout: "list",
      name: "",
      ShopsList: [],
      hotels: [],
      category: "عتبات",
      FId: "",
      usersList: [],
      type: "bus",
      year: "1401",
      fromDate: moment(),
      getAll: false,
      typeOfDevices: [
        {
          label: "زمینی",
          value: "bus",
        },
        {
          label: "هوایی",
          value: "air",
        },
      ],
      priceAdult: "",
      priceKid: "",
      priceBaby: "",
      mounth: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      key: [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "toelve",
      ],
      showDiv: showDiv,
      Mounth: Mounth,
      userChecked: [],
    };
  }

  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState(
        {
          user_Id: response.data.authData.userId,
          loading: 0,
        },
        () => {
          that.getManagerSystemInfo();
        }
      );
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  getManagerSystemInfo() {
    let that = this;
    let param = {
      user_id: this.state.user_Id,
    };
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      console.log(response);

      that.setState(
        {
          loading: 0,
          mySystem:
            response.data.result[0] && response.data.result[0].system[0]
              ? response.data.result[0].system[0]
              : { subSystem: false },
          userSystemIds: response.data.result[0]
            ? response.data.result[0].systemId
            : null,
        },
        () => {
          that.getSystems();
        }
      );
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.getSystems();
    };
    this.Server.send(
      "MainApi/getManagerSystemInfo",
      param,
      SCallBack,
      ECallBack
    );
  }
  getSystems() {
    let that = this;
    let SCallBack = function (response) {
      let systemId = [];
      if (response.data.result) {
        for (let i = 0; i < response.data.result.length; i++) {
          if (
            that.state.userSystemIds.some((item) => {
              return item._id === response.data.result[i]._id;
            })
          )
            systemId.push({
              value: response.data.result[i]._id,
              name: response.data.result[i].name,
            });
        }
      }
      that.setState({
        systems: systemId,
        managerSystem:
          that.state.mySystem && that.state.mySystem._id
            ? that.state.mySystem._id
            : response.data.result[0]
            ? response.data.result[0]._id
            : null,
      });
      that.getHotels();
    };
    let ECallBack = function (error) {
      that.getHotels();
    };
    this.Server.send("MainApi/getSystems", {}, SCallBack, ECallBack);
  }
  SetGroups() {
    let that = this;
    if (!this.state.system) {
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "سیستم را وارد کنید",
        life: 3000,
      });
      return null;
    }
    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      type: this.state.type,
      enable: this.state.enable,
      category: this.state.category,
      system: that.state.system,
      fromDate_en: this.state.fromDate
        ? this.state.fromDate.local("en").format("YYYY/M/D")
        : "",
      fromDate: this.state.fromDate
        ? this.state.fromDate.local("fa").format("jYYYY/jM/jD")
        : "",
      price: {
        adult: this.state.priceAdult.toString().replace(/,/g, ""),
        kid: this.state.priceKid.toString().replace(/,/g, ""),
        baby: this.state.priceBaby.toString().replace(/,/g, ""),
      },
      capacity: this.state.capacity,
      oldCapacity: this.state.oldCapacity,
      Time: this.state.Time,
      hotels: this.state.selectedHotels,
      desc: this.state.desc,
    };
    this.setState({
      HasErrorForMaps: null,
      loading: 1,
    });
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.getTravelGroups(that.state.getAll);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 5000,
      });
    };
    this.Server.send("CompanyApi/setTravelGroups", param, SCallBack, ECallBack);
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      priceKid: 0,
      priceAdult: 0,
      priceBaby: 0,
      enable: true,
      desc: "",
      capacity: 0,
      Time: 0,
      selectedHotels: [],
      type: "bus",
      system: null,
      selectedId: null,
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
    });
  }
  onHideMapsDialog(event) {
    this.setState({
      visibleManageMaps: false,
      HasErrorForMaps: null,
    });
  }
  selectedComponentChange(value) {
    this.setState({
      priceKid: value.price.kid
        ? value.price.kid
            .replace(/,/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : 0,
      priceAdult: value.price.adult
        ? value.price.adult
            .replace(/,/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : 0,
      priceBaby: value.price.baby
        ? value.price.baby
            .replace(/,/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : 0,
      fromDate: moment(value.fromDate, "jYYYY/jMM/jDD"),
      enable: value.enable,
      type: value.type,
      category: value.category,
      capacity: value.originalCapacity,
      oldCapacity: value.originalCapacity,
      Time: value.Time,
      desc: value.desc,
      TimeInNajaf: value.TimeInNajaf,
      selectedHotels: value.hotels
        ? value.hotels.map((item) => {
            return { _id: item._id, name: item.name, dates: item.dates };
          })
        : [],
      system: value.system,
      selectedId: value._id,
      visibleManageField: true,
    });
  }
  getTravelGroups(getAll) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      category: "atabat",
      getAll: getAll,
      userSystemIds: this.state.userSystemIds,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getTravelGroups", param, SCallBack, ECallBack);
  }
  delField(rowData) {
    this.setState({
      visibleManageField: false,
    });
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: (
        <span className="yekan"> آیا از حذف {rowData.name} مطمئنید </span>
      ),
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              system: that.state.system,
              del: 1,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
              });
              that.getTravelGroups(that.state.getAll);
              that.toast.current.show({
                severity: "success",
                summary: "",
                detail: "عملیات با موفقیت انجام شد",
                life: 3000,
              });
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({
                severity: "error",
                summary: "خطای سرور",
                detail: "عملیات انجام نشد",
                life: 5000,
              });
            };
            this.Server.send(
              "CompanyApi/SetTravelGroups",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          username={brand.username}
        >
          <div
            className="col-8"
            username={brand.username}
            style={{ textAlign: "right" }}
          >
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              username={brand.username}
            >
              <span
                style={{ whiteSpace: "pre-wrap" }}
                username={brand.username}
              >
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }
  getHotels() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        hotels: response.data.result,
        loading: 0,
      });
      that.getTravelGroups(that.state.getAll);
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.getTravelGroups(that.state.getAll);
    };
    this.Server.send("CompanyApi/getHotels", param, SCallBack, ECallBack);
  }
  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetGroups}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );

    const amountTemplate = (rowData, props) => {
      if (rowData.price && rowData.price.adult) {
        return (
          <span>
            {rowData.price.adult
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        );
      } else {
        return "-";
      }
    };
    const typeTemplate = (rowData, props) => {
      if (rowData.type == "air") {
        return (
          <span>
            <i className="fas fa-plane" style={{ color: "green" }}></i>
          </span>
        );
      } else {
        return (
          <span>
            <i className="fas fa-bus" style={{ color: "green" }}></i>
          </span>
        );
      }
    };

    return (
      <div style={{ direction: "rtl" }}>
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center">
          <div className="col-12" style={{ background: "#fff" }}>
            <div>
              <div>
                <div className="group">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <Checkbox
                      inputId="active"
                      value={this.state.getAll}
                      checked={this.state.getAll}
                      onChange={(e) => {
                        this.setState({ getAll: e.checked });
                        this.getTravelGroups(e.checked);
                      }}
                    ></Checkbox>
                    <label
                      htmlFor="active"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      نمایش همه گروهها
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <Panel
              header="لیست گروهها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-primary irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ساخت ردیف جدید
                  </button>
                </div>
              </div>
              <div>
                <DataTable
                  value={this.state.GridDataFields}
                  selectionMode="single"
                  selection={this.state.selectedComponent}
                  onSelectionChange={(e) =>
                    this.selectedComponentChange(e.value)
                  }
                  size="small"
                >
                  <Column
                    field="fromDate"
                    header="تاریخ حرکت"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="type"
                    header="نوع حرکت"
                    className="irsans"
                    body={typeTemplate}
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="desc"
                    header="توضیحات"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="originalCapacity"
                    header="ظرفیت"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="capacity"
                    header="باقیمانده"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="Time"
                    header="مدت اقامت"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                  <Column
                    field="Time"
                    body={amountTemplate}
                    header="مبلغ"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                </DataTable>
              </div>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "اصلاح" : "ساخت ردیف جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          minY={70}
          onHide={this.onHideFormsDialog}
          maximizable={false}
          maximized={true}
        >
          <div className="row" style={{ alignItems: "baseline" }}>
            {this.state.systems && (
              <div className="col-lg-4">
                <div>
                  <label className="labelNoGroup irsans">سیستم</label>
                  <select
                    className="form-control irsans"
                    value={this.state.system}
                    name="system"
                    onChange={(event) => {
                      this.setState({
                        system: event.target.value,
                      });
                    }}
                  >
                    <option value="null">
                      {" "}
                      سیستم مربوط به مدیر را انتخاب کنید
                    </option>
                    {this.state.systems &&
                      this.state.systems.map((v, i) => {
                        return <option value={v.value}>{v.name}</option>;
                      })}
                  </select>
                </div>
              </div>
            )}
            {this.state.systems && <div className="col-lg-9"></div>}
            <div className="col-lg-12 mt-3">
              <div style={{ display: "flex", alignItems: "center" }}>
                <SelectButton
                  value={this.state.type}
                  style={{ direction: "ltr" }}
                  options={this.state.typeOfDevices}
                  onChange={(e) => {
                    this.setState({
                      type: e.value === null ? this.state.type : e.value,
                    });
                  }}
                ></SelectButton>
              </div>
            </div>
            <div className="col-lg-3 mt-3" style={{ display: "none" }}>
              <div className="group">
                <input
                  className="form-control irsans"
                  disabled={true}
                  autoComplete="off"
                  type="text"
                  value={this.state.category}
                  name="category"
                  onChange={(event) =>
                    this.setState({ category: event.target.value })
                  }
                  required="true"
                />
                <label>نوع گروه</label>
              </div>
            </div>

            <div class="col-lg-4 col-12  mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>قیمت برای بزرگسال</label>
                <input
                  className="form-control yekan"
                  autoComplete="off"
                  type="text"
                  value={this.state.priceAdult}
                  name="priceAdult"
                  onChange={(event) => {
                    this.setState({
                      priceAdult: event.target.value
                        .toString()
                        .replace(/,/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    });
                  }}
                  required="true"
                />
              </div>
            </div>
            <div class="col-lg-4 col-12  mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>قیمت برای کودک</label>
                <input
                  className="form-control yekan"
                  autoComplete="off"
                  type="text"
                  value={this.state.priceKid}
                  name="priceKid"
                  onChange={(event) => {
                    this.setState({
                      priceKid: event.target.value
                        .toString()
                        .replace(/,/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    });
                  }}
                  required="true"
                />
              </div>
            </div>
            <div class="col-lg-4 col-12  mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>قیمت برای نوزاد</label>
                <input
                  className="form-control yekan"
                  autoComplete="off"
                  type="text"
                  value={this.state.priceBaby}
                  name="priceBaby"
                  onChange={(event) => {
                    this.setState({
                      priceBaby: event.target.value
                        .toString()
                        .replace(/,/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    });
                  }}
                  required="true"
                />
              </div>
            </div>
            <div className="col-lg-3 col-12 mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>ظرفیت</label>

                <InputNumber
                  value={this.state.capacity}
                  inputStyle={{
                    borderRadius: 0,
                    padding: 0,
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  style={{ direction: "ltr" }}
                  mode="decimal"
                  showButtons
                  onValueChange={(e) => {
                    this.setState({
                      capacity: e.value,
                    });
                  }}
                  min={1}
                  max={1000}
                />
              </div>
            </div>
            <div class="col-lg-3 col-12 mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>
                  <span>مدت کل اقامت</span>
                </label>
                <InputNumber
                  value={this.state.Time}
                  inputStyle={{
                    borderRadius: 0,
                    padding: 0,
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  style={{ direction: "ltr" }}
                  mode="decimal"
                  showButtons
                  onValueChange={(e) => {
                    this.setState({
                      Time: e.value,
                    });
                  }}
                  min={0}
                  max={1000}
                />
              </div>
            </div>

            <div className="col-lg-4 mt-3">
              <div
                style={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>تاریخ حرکت</label>

                <DatePicker
                  onChange={(value) => this.setState({ fromDate: value })}
                  value={this.state.fromDate}
                  isGregorian={false}
                  timePicker={false}
                  placeholder="تاریخ"
                  persianDigits={false}
                />
              </div>
            </div>
            <div className="col-lg-12" style={{ marginTop: 20 }}>
              <Multiselect
                options={this.state.hotels} // Options to display in the dropdown
                displayValue="name" // Property name to display in the dropdown options
                selectedValues={this.state.selectedHotels}
                placeholder="هتل ها"
                onSelect={(selectedList, selectedItem) => {
                  const selected = selectedList.map((item) => {
                    return {
                      _id: item._id,
                      name: item.name,
                      dates: item.dates,
                    };
                  });
                  this.setState({
                    selectedHotels: selected,
                  });
                }}
                onRemove={(selectedList, selectedItem) => {
                  const selected = selectedList.map((item) => {
                    return {
                      _id: item._id,
                      name: item.name,
                      dates: item.dates,
                    };
                  });
                  this.setState({
                    selectedHotels: selected,
                  });
                }}
              />
            </div>
            <div className="col-lg-12" style={{ marginTop: 20 }}>
              <div
                style={{
                  maxWidth: 600,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {this.state.selectedHotels &&
                  this.state.selectedHotels.map((item) => {
                    return (
                      <div style={{ width: "100%", textAlign: "right" }}>
                        <Button
                          onClick={(event) => {
                            this.setState({
                              visibleSetDate: true,
                              selectedHotelId: item._id,
                              userChecked: item.dates || [],
                            });
                            return false;
                          }}
                          style={{ marginLeft: 20 }}
                        >
                          <span>{item.name}</span>
                        </Button>
                        <div className="mt-2" style={{ display: "flex" }}>
                          {item.dates &&
                            item.dates.map((ddd) => {
                              return (
                                <Tag
                                  className="ml-md-1 ml-0"
                                  severity="info"
                                  value={
                                    ddd.year + "/" + ddd.mounth + "/" + ddd.day
                                  }
                                ></Tag>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="group">
                <textarea
                  className="form-control irsans"
                  autoComplete="off"
                  type="text"
                  value={this.state.desc}
                  name="desc"
                  onChange={(event) =>
                    this.setState({ desc: event.target.value })
                  }
                  required="true"
                />
                <label>توضیحات</label>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="group">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    inputId="active"
                    value={this.state.enable}
                    checked={this.state.enable}
                    onChange={(e) => this.setState({ enable: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="active"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5, marginBottom: 0 }}
                  >
                    فعال
                  </label>
                </div>
              </div>
            </div>
          </div>
          <Dialog
            header="روزهای اقامت"
            visible={this.state.visibleSetDate}
            onHide={() => {
              this.state.selectedHotels.map((item) => {
                if (this.state.selectedHotelId == item._id) {
                  item.dates = this.state.userChecked;
                }
              });

              this.setState({
                visibleSetDate: false,
                selectedHotelId: null,
                userChecked: [],
                selectedHotels: this.state.selectedHotels,
              });
            }}
          >
            {this.state.mounth.map((item, index) => {
              return (
                this.state.Mounth &&
                this.state.showDiv == index && (
                  <div
                    style={{
                      border: "1px solid #eee",
                      textAlign: "center",
                      padding: 10,
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="no-scroll-bar"
                        style={{
                          display: "inline",
                          flexWrap: "wrap",
                          overflow: "auto",
                          direction: "rtl",
                        }}
                      >
                        {this.state.mounth.map((item, index2) => {
                          let key = this.state.key[index2];
                          let prev = index2 - 1;
                          let next = index2 + 1;
                          return (
                            this.state.Mounth &&
                            this.state.showDiv == index2 && (
                              <div
                                style={{
                                  border: "1px solid #eee",
                                  textAlign: "center",
                                  padding: 10,
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                  }}
                                >
                                  {index2 != 0 ? (
                                    <div>
                                      <i
                                        class="fas fa-angle-double-right"
                                        onClick={() => {
                                          this.setState({
                                            showDiv: prev,
                                          });
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      <i />
                                    </div>
                                  )}
                                  <div>
                                    <p
                                      className="iranyekanwebmedium"
                                      style={{ textAlign: "center" }}
                                    >
                                      {this.state.mounth[index2]}
                                    </p>
                                  </div>
                                  {index2 != 11 ? (
                                    <div>
                                      <i
                                        class="fas fa-angle-double-left"
                                        onClick={() => {
                                          this.setState({
                                            showDiv: next,
                                          });
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      <i />
                                    </div>
                                  )}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexWrap: "wrap",
                                    maxWidth: 400,
                                  }}
                                >
                                  {this.state.Mounth[key] &&
                                    this.state.Mounth[key].length > 0 &&
                                    this.state.Mounth[key].map(
                                      (item, index3) => {
                                        return (
                                          <ToggleButton
                                            style={{
                                              width: "25%",
                                              direction: "rtl",
                                              color:
                                                item.weekName == "5" ||
                                                item.free
                                                  ? "red"
                                                  : "#000",
                                            }}
                                            checked={this.state.userChecked.some(
                                              (iii) => {
                                                return (
                                                  iii._id ==
                                                    this.state
                                                      .selectedHotelId &&
                                                  iii.day == item.label &&
                                                  iii.mounth == index + 1 &&
                                                  iii.year == this.state.year
                                                );
                                              }
                                            )}
                                            disabled={
                                              item.checked && !item.userChecked
                                            }
                                            offLabel={item.label}
                                            onLabel={item.label}
                                            onChange={(e) => {
                                              item.checked = e.value;
                                              item.userChecked = e.value;
                                              let userChecked =
                                                this.state.userChecked;
                                              if (e.value)
                                                userChecked.push({
                                                  day: item.label,
                                                  mounth: index + 1 + "",
                                                  year: this.state.year,
                                                  _id: this.state
                                                    .selectedHotelId,
                                                });
                                              else {
                                                userChecked.splice(
                                                  userChecked.findIndex(
                                                    (x) =>
                                                      x._id ==
                                                        this.state
                                                          .selectedHotelId &&
                                                      x.day == item.label &&
                                                      x.mounth ==
                                                        index + 1 + "" &&
                                                      x.year == this.state.year
                                                  ),
                                                  1
                                                );
                                              }

                                              this.setState({
                                                userChecked: userChecked,
                                              });
                                            }}
                                          />
                                        );
                                      }
                                    )}
                                </div>
                              </div>
                            )
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </Dialog>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Travel_Group);
